import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { useNavigate } from "react-router-dom";
import {
  addGRNDetailNumber,
  addPoDetailNumber,
  getGoodsReceivedNote,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../../Components/formElements/SearchField";
import {
  currencyFormat,
  formatDate,
  formatDateTime,
  formatDateWithAMPM,
} from "../../../../common/Validations";
// import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CustomerConstants from "../../../../common/CustomerConstants";
import GrnCancelModal from "./GrnCancelModal";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
// import toast from "react-hot-toast";

const GoodsReceivedNoteList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Goods Received Note");

  let goods_received_noteData = useSelector(
    (state) => state?.purchasing?.goods_received_note,
  ); // get goods_received_note from Store

  let goods_received_noteDataTable = useSelector(
    (state) => state?.purchasing?.goods_received_note?.pagination,
  ); // goods_received_noteDataTable Details from Store

  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.GRN?.module,
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  /* Modal Function */
  // eslint-disable-next-line
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialPageData = async (page) => {
    // let obj = {
    //   queryName: "getGrnList",
    //   page: page,
    //   per_page: getNewPerPage,
    //   // searchTerm: getCommonSearchTxt,
    // };

    // dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData.data);
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goods_received_noteData]);

  // useEffect(() => {
  //   let obj = {
  //     queryName: "getGrnList",
  //     page: 1,
  //     per_page: 10,
  //   };
  //   dispatch(getGoodsReceivedNote(obj));
  // setData(goods_received_noteData.data);

  // }, [dispatch]);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "getGrnList",
  //     page: page,
  //     per_page: getNewPerPage,
  //     searchTerm: getCommonSearchTxt,
  //   };

  //   dispatch(getGoodsReceivedNote(obj));
  //   setData(goods_received_noteData?.data);
  // };
  const [filterShow, setFilterShow] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const columnsForFilter = [
    { id: "grnNr", name: "GRN Number", selectorKey: "grnNr" },
    { id: "grnStatus", name: "GRN Status", selectorKey: "grnStatus" },
    { id: "vendorCode", name: "Vendor Code", selectorKey: "vendorCode" },
    { id: "vendorName", name: "Vendor Name", selectorKey: "vendorName" },
    {
      id: "purchasingDocumentNr",
      name: "PO/SA Number",
      selectorKey: "purchasingDocumentNr",
    },
    {
      id: "vendorInvoiceNo",
      name: "Invoice No",
      selectorKey: "vendorInvoiceNo",
    },
    {
      id: "sumOfGrn",
      name: "GRN Value",
      selectorKey: "sumOfGrn",
      numberRange: true,
    },
    {
      id: "createdAt",
      name: "GRN Date",
      selectorKey: "createdAt",
      month: true,
    },
  ];
  const handleFilterData = async (filters) => {
    setActiveFilters(filters); // ← save filters
    const obj = {
      queryName: "getGrnList",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getGrnList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  // Common Search Function on button
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     // queryName: "getGrnList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getGoodsReceivedNote(obj));
  // };
  const handleSearchFuncApi = async () => {
    setActiveFilters([]); // ← clear filters when searching
    let obj = {
      queryName: "getGrnList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     // queryName: "getGrnList",
  //     page: page,
  //     per_page: newPerPage,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(getGoodsReceivedNote(obj));
  //   setData(goods_received_noteData?.data);
  // };
  const handlePerRowsChange = async (newPerPage, page) => {
    setNewPerPage(newPerPage);
    let obj = {
      queryName: "getGrnList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  const detailedPage = (grnNumber) => {
    dispatch(addGRNDetailNumber(grnNumber));
    navigate(CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GRN_DETAILS);
  };
  // const qualityCheck = (grnNumber) => {
  //   dispatch(addGRNDetailNumber(grnNumber));
  //   navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_CREATE_MR);
  // };

  const qualityCheck = (grnNumber) => {
    // let obj = {
    //   asnNumber: "",
    //   subTransactionActivity: "PO",
    //   grnNumber: "",
    // };
    dispatch(addGRNDetailNumber(grnNumber));

    navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_CREATE_MR);
  };

  const detailedPagePO = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
    navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_DETAILS);
  };
  // LocalStorage nundi userData string techukuni object ga marchali
  const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");

  // roles array nundi roleId ni verify cheyali
  const userRoles = storedUserData?.data?.roles || [];
  const isQualityCheckUser = userRoles.some(
    (role) => role.roleId === "QUALITYCHECK",
  );
  // eslint-disable-next-line
  const [getHeaderData, setHeaderData] = useState(false);
  const columns = [
    {
      name: "GRN Number",
      selector: (row) => row.grnNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.grnNr)}>
          {row.grnNr}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },

    ...(isQualityCheckUser
      ? [
          {
            name: "Quality Check",
            selector: (row) => row.grnNr,
            cell: (row) => (
              <button
                className="btn btnInfo bi bi-plus"
                disabled={row?.qualityCheckDetails?.length > 0}
                onClick={() => qualityCheck(row.grnNr)}
              >
                Create
              </button>
            ),
            sortable: true,
            width: "150px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    // Conditionally include the 'workflowActionLogs' column
    // ...(data?.some((row) => row.workflowActionLogs !== undefined)
    //   ? [
    //     {
    //       name: "Workflow log",
    //       selector: (row) => row.workflowActionLogs,
    //       cell: (row) => (
    //         <div
    //           style={{ width: "100%" }}
    //           className="d-flex justify-content-center iconTable"
    //         >
    //           <img
    //             src="assets/img/newIcons/workflow.png"
    //             alt="attachments"
    //             style={{ width: "35px" }}
    //             className="mt-1"
    //             onClick={() => showStatusInfo(row.workflowActionLogs)}
    //           />
    //         </div>
    //       ),
    //       sortable: true,
    //       width: "132px",
    //     },
    //   ]
    //   : []),

    // {
    //   name: "Status",
    //   selector: (row) => row.grnStatusHeader,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.grnStatusHeader} />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Grn  Status",
      selector: (row) => row.grnStatus,
      cell: (row) => (
        <>
          <TableStatusField status={row.grnStatus} />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "GRN Date/Time",
      selector: (row) => formatDateTime(row.createdAt) || "--",
      cell: (row) => <span>{formatDateWithAMPM(row.createdAt) || "--"}</span>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "Quality Check",
      sortable: true,
      width: "220px",
      selector: (row) =>
        row?.qualityCheckDetails?.[0]?.qualityCheckStatus || "QC Pending",

      cell: (row) => {
        const qc = row?.qualityCheckDetails?.[0];

        return (
          <div>
            {qc?.qualityCheckNr ? (
              <>
                <p className="m-0 p-0 fw-bold text-muted">
                  {qc.qualityCheckNr}
                </p>
                <p className="m-0 p-0 text-muted fs-12">
                  {qc.qualityCheckDate}
                </p>
                <p className="m-0 p-0 fw-bold text-primary">
                  {qc.qualityCheckStatus}
                </p>
              </>
            ) : (
              <p className="m-0 p-0 fw-bold text-warning">QC Pending</p>
            )}
          </div>
        );
      },
    },

    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.sumOfGrn).toFixed(2))}
          <span className="m-1 p-0 pt-1 fw-bold ms-1 text-primary">
            {row.currencyCode}
          </span>
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0">{row.currency} </p>
    //     </div>
    //   ),

    //   width: "150px",
    // },
    {
      name: "PO/SA Number",
      selector: (row) => row.purchasingDocumentNr,
      cell: (row) => (
        <>
          {row.purchasingDocumentNr && (
            <button
              className="btnInfo"
              onClick={() => detailedPagePO(row.purchasingDocumentNr)}
            >
              {row.purchasingDocumentNr}{" "}
            </button>
          )}
          {!row.purchasingDocumentNr && (
            <>
              {" "}
              <p>--</p>{" "}
            </>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Date/Time",
      selector: (row) =>
        formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Invoice Attachement",
      cell: (row) => (
        <div>
          {(row?.shippingDocuments && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row?.shippingDocuments)}
            />
          )) ||
            "--"}
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "INV Nr/Dt",
      selector: (row) =>
        formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.vendorInvoiceNo}</p>
          <p className="p-0 m-0">{formatDate(row?.vendorInvoiceDate)}</p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "INV/GST",
      selector: (row) =>
        formatDateWithAMPM(row?.vendorTotalInvoiceValue) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">
            AMT {row?.vendorTotalInvoiceValue}
          </p>
          <p className="p-0 m-0 fw-medium">
            {row?.grnGstValue ? `GST ${row?.grnGstValue}` : "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "INV Amt",
      selector: (row) =>
        formatDateWithAMPM(row?.vendorTotalInvoiceValue) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.purchasingDocumentValue}</p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "E-Way Bill",
      selector: (row) =>
        formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.ewayBillNumber}</p>
          <p className="p-0 m-0">{formatDate(row?.ewayBillExpiryDate)}</p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Delivery Note",
      selector: (row) => row.grnRemark || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "GRN Cancel",
      selector: (row) => row.grnStatusHeader,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          {row.grnStatusHeader === "Cancelled" ? (
            <p className="m-0 p-0 pt-1 text-danger fw-bold">
              {row.grnStatusHeader}{" "}
            </p>
          ) : (
            <p className="m-0 p-0 pt-1 text-success fw-bold">
              {row.grnStatusHeader}{" "}
            </p>
          )}
          <p className="m-0 p-0 text-danger">{row.cancellationRemark} </p>
        </div>
      ),
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "PO Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },

    {
      name: "GRN Quantity",
      cell: (row) => <span>{row.grnQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];
  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.grnStatusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };

  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  //view attachment file
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Goods Received Note</h2>
                <p className="subText">
                  Lists of Goods Received Note and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">GR</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">GRN List</span>
                      <span className="subHeaderTitle">
                        View of Goods Received Note and Status{" "}
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs={6} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={goods_received_noteData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={
                            goods_received_noteDataTable.total
                          }
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <GrnCancelModal
        title="Cancel the GRN"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        showDelete={false}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default GoodsReceivedNoteList;
